interface Options {
    removeOtherMatches?: boolean
    /** If not found, prepend or append */
    handleNotFound?: 'append' | 'prepend'
    /** To better Safari's lack of lookbehind (https://caniuse.com/js-regexp-lookbehind), use this if needed to skipping matches based on a pattern, or some other function */
    // filterPattern?: string | RegExp
    filter?: (match: string) => boolean
}

/** Replace first instance only. Trims leading and multiple consecutive spaces as well. */
export const replaceFirst = (
    prior: string,
    pattern: string | RegExp,
    replacement: string,
    options: Options = {},
): string => {
    const { removeOtherMatches = false, handleNotFound, filter } = options
    const regex = pattern instanceof RegExp ? pattern : new RegExp(pattern, 'gi')

    if (!regex.global) {
        throw new Error('replaceFirst requires a global RegExp')
    }

    const posterior = ((): string => {
        let matchIndex = 0

        const replacedIfMatched = prior.replace(regex, (match) => {
            const shouldFilterMatch = filter?.(match) || false

            if (shouldFilterMatch) {
                return match
            }

            matchIndex += 1

            // Replace first match only
            if (matchIndex === 1) {
                // Extra spaces to handle any leading spaces regex
                if (match.includes(':') && replacement.includes(':')) {
                    const matchKey = match.split(':')[0]
                    const replacementValue = replacement.split(':')[1]

                    return ` ${matchKey}:${replacementValue} `
                }

                return ` ${replacement} `
            }

            // Handle removing other matches
            return removeOtherMatches ? '' : match
        })

        // If no match found, matchIndex would still be zero
        if (matchIndex === 0 && handleNotFound) {
            return handleNotFound === 'append' ? ` ${prior} ${replacement} ` : ` ${replacement} ${prior} `
        }

        return replacedIfMatched
    })()

    const trimmed = posterior.trim().replace(/\s\s+/g, ' ')
    return trimmed
}

export type { Options as ReplaceFirstOptions }
